// useFavouritesMutations.js

import { useMutation, useQueryClient } from '@tanstack/react-query';
import AccountService from '../Services/users/AccountService';
import { toast } from 'sonner';
import { GET_USER_FAVOURITES_QUERY_KEY } from '../queries';

export const useFavouritesMutations = () => {
  const queryClient = useQueryClient();

  const addToFavouritesMutation = useMutation({
    mutationFn: ({ itemId, itemType }) => AccountService.addToFavourites(itemId, itemType),
    onSuccess: (data) => {
      queryClient.invalidateQueries([GET_USER_FAVOURITES_QUERY_KEY]); 
      toast.success('Item added to favourites');
    },
    onError: (error) => {
      toast.error(`Failed to add item to favourites: ${error.message}`);
    },
  });

  const removeFromFavouritesMutation = useMutation({
    mutationFn: ({ itemId, itemType }) => AccountService.removeFromFavourites(itemId, itemType),
    onSuccess: (data) => {
      queryClient.invalidateQueries([GET_USER_FAVOURITES_QUERY_KEY]); 
      toast.success('Item removed from favourites');
    },
    onError: (error) => {
      toast.error(`Failed to remove item from favourites: ${error.message}`);
    },
  });

  return {
    addToFavouritesMutation,
    removeFromFavouritesMutation,
  };
};